import React, { useState, useEffect } from 'react'
import { T, Spinner, Empty, probColor } from '../ui'
import { getNFLMarketPulse } from '../api'
import { teamNick } from '../plain'

// Market Pulse — line movement (open → now) across the slate, biggest movers first. The edge
// over a pure mover feed: a tag for whether the market moved WITH or AGAINST the model.
function Row({ r }) {
  const up = (r.move || 0) > 0
  const flat = !r.move
  const moveColor = flat ? T.muted : up ? T.green : T.amber
  const agree = r.agree === true, against = r.agree === false
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: T.card,
      border: `1px solid ${agree ? T.greenMid : T.border}`, borderRadius: 11, padding: '10px 12px', marginBottom: 7 }}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {r.name} <span style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>{r.pos}</span>
        </div>
        <div style={{ fontSize: 10.5, color: T.muted, marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {r.market}{r.opp ? ` · vs ${teamNick(r.opp)}` : ''}
          {agree && <span style={{ color: T.green, fontWeight: 800 }}> · ✓ with the model</span>}
          {against && <span style={{ color: T.amber, fontWeight: 800 }}> · ✗ against</span>}
        </div>
      </div>
      <div style={{ textAlign: 'center', flexShrink: 0, fontFamily: T.mono }}>
        <div style={{ fontSize: 12, color: T.muted2 }}>{r.line_open} → <b style={{ color: T.text }}>{r.line_now}</b></div>
        <div style={{ fontSize: 13, fontWeight: 900, color: moveColor, marginTop: 1 }}>
          {flat ? '—' : `${up ? '+' : ''}${r.move}`}</div>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0, minWidth: 42 }}>
        <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 15, lineHeight: 1, color: probColor((r.model_pct || 0) / 100) }}>{r.model_pct}%</div>
        <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>MODEL</div>
      </div>
    </div>
  )
}

export default function MarketPulseTab({ season = 2026, week = 1 }) {
  const [d, setD] = useState(null)
  useEffect(() => { let a = true; setD(null)
    getNFLMarketPulse(season, week).then(r => { if (a) setD(r) }); return () => { a = false } }, [season, week])
  const movers = d?.movers || []
  return (
    <div style={{ padding: '12px 16px 80px' }}>
      <div style={{ fontSize: 12, color: T.muted, lineHeight: 1.5, marginBottom: 12 }}>
        <b style={{ color: T.text }}>Market Pulse.</b> How each line has moved since it opened, biggest movers first —
        and the part other trackers miss: whether the move went <b style={{ color: T.green }}>with</b> or
        <b style={{ color: T.amber }}> against</b> the model. Research only · 21+.
      </div>
      {!d ? <Spinner />
        : movers.length === 0 ? <Empty message="No line movement yet — this fills in once books have posted and moved their lines." />
        : (<>
          {d.sharp_confirms > 0 && (
            <div style={{ fontSize: 11, color: T.muted, marginBottom: 10 }}>
              <b style={{ color: T.green }}>{d.sharp_confirms}</b> sharp confirmation{d.sharp_confirms === 1 ? '' : 's'} (market steaming our way) · {movers.length} tracked
            </div>
          )}
          {movers.map((r, i) => <Row key={`${r.gsis_id}-${r.prop_type}-${i}`} r={r} />)}
        </>)}
    </div>
  )
}
